








import { Vue, Component } from "vue-property-decorator";

import CartBlock from "./CartButton.vue";
import DropDownMenu from "./DropDownMenu.vue";
import NotificationsButton from "./NotificationsButton.vue";

import { personalModule } from "@/plugins/store-accessors";

@Component({
  components: {
    NotificationsButton,
    DropDownMenu,
    CartBlock,
  },
})
export default class Personal extends Vue {
  get isAuthorized() {
    return personalModule.isAuthorized;
  }
}
